export enum PaymentMethod {
    Unknown = 0,
    Visa = 1,
    Mastercard = 2,
    Amex = 3,
    Discover = 4,
    RoomCharge = 5,
    Diners = 6,
    JCB = 7,
    GiftCard = 8,
    Cash = 9
}

